import { type FirebaseApp, getApps, initializeApp } from 'firebase/app';
import { connectFirestoreEmulator, initializeFirestore, type Firestore } from 'firebase/firestore';
import { getAuth, signInWithCustomToken, type UserCredential } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator, type Functions } from 'firebase/functions';

import { ENVIRONMENT } from '@/constants';

const firebaseConfig = {
  apiKey: ENVIRONMENT.VITE_FIREBASE_API_KEY,
  authDomain: ENVIRONMENT.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: ENVIRONMENT.VITE_FIREBASE_PROJECT_ID,
  storageBucket: ENVIRONMENT.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: ENVIRONMENT.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: ENVIRONMENT.VITE_FIREBASE_APP_ID,
};

export function getFirebaseApp(): FirebaseApp {
  return getApps()[0] ?? initializeApp(firebaseConfig);
}

export class FirebaseService {
  private app: FirebaseApp;
  public readonly firestore: Firestore;
  public readonly functions: Functions;

  constructor() {
    this.app = getFirebaseApp();
    this.firestore = initializeFirestore(this.app, {});
    this.functions = getFunctions(this.app);

    this.connectToEmulator(this.firestore, this.functions);
  }

  async authenticateWithToken(customToken: string): Promise<UserCredential> {
    const auth = getAuth(this.app);
    return signInWithCustomToken(auth, customToken);
  }

  private connectToEmulator(firestore: Firestore, functions: Functions) {
    if (ENVIRONMENT.VITE_FIRESTORE_EMULATOR_HOST && ENVIRONMENT.VITE_FIRESTORE_EMULATOR_PORT) {
      console.log(
        '🔧 connecting to firestore emulator',
        ENVIRONMENT.VITE_FIRESTORE_EMULATOR_HOST,
        ENVIRONMENT.VITE_FIRESTORE_EMULATOR_PORT
      );
      connectFirestoreEmulator(firestore, ENVIRONMENT.VITE_FIRESTORE_EMULATOR_HOST, ENVIRONMENT.VITE_FIRESTORE_EMULATOR_PORT);
    }

    if (ENVIRONMENT.VITE_FUNCTIONS_EMULATOR_HOST && ENVIRONMENT.VITE_FUNCTIONS_EMULATOR_PORT) {
      console.log(
        '🔧 connecting to functions emulator',
        ENVIRONMENT.VITE_FUNCTIONS_EMULATOR_HOST,
        ENVIRONMENT.VITE_FUNCTIONS_EMULATOR_PORT
      );
      connectFunctionsEmulator(functions, ENVIRONMENT.VITE_FUNCTIONS_EMULATOR_HOST, ENVIRONMENT.VITE_FUNCTIONS_EMULATOR_PORT);
    }
  }
}
